
import { Action, State } from './types';
import { initialValues } from './utils';

export function authReducer(state: State, action: Action) {
  switch (action.type) {
    case 'setUser': {
      if (action.data) {
        const { token } = action.data;
        localStorage.setItem("token", token);
        return {
          ...state,
          user: action.data,
          authToken: token,
          refetch: false
        }
      }
      return {
        ...state,
        user: null,
        authToken: null,
        refetch: false
      }
    }
    case 'setToken': {
      localStorage.setItem('token', action.data);
      return {
        ...state,
        authToken: action.data,
        refetch: true
      }
    }
    case 'logout': {
      localStorage.removeItem('token');
      return initialValues;
    }
    case 'setRefetch': {
      return {
        ...state,
        refetch: action.data,
      }
    }
    case "setRootData": {
      const { mapUrl } = action.data;
      return {
        ...state,
        mapUrl
      }
    }
    default: {
      throw Error ("Error - unknown action type");
    }
  }
}
